import { render, staticRenderFns } from "./turntableRecord.vue?vue&type=template&id=38188f37&scoped=true"
import script from "./turntableRecord.vue?vue&type=script&lang=js"
export * from "./turntableRecord.vue?vue&type=script&lang=js"
import style0 from "./turntableRecord.vue?vue&type=style&index=0&id=38188f37&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38188f37",
  null
  
)

export default component.exports